/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IStETHLike, IStETHLikeInterface } from "../IStETHLike";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_sharesAmount",
        type: "uint256",
      },
    ],
    name: "getPooledEthByShares",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IStETHLike__factory {
  static readonly abi = _abi;
  static createInterface(): IStETHLikeInterface {
    return new utils.Interface(_abi) as IStETHLikeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IStETHLike {
    return new Contract(address, _abi, signerOrProvider) as IStETHLike;
  }
}
